import type { ReactNode } from 'react'

/*
  Culoarea spune ce fel de cifra e (Madalin, 09.10.2026): albastru — comenzile si ce e in ele;
  mov — oamenii; verde — banii incasati; chihlimbar — banii dati inapoi ca discount; rosu — ce
  s-a intors. Aceeasi pe toate ecranele Shopify, ca o culoare sa insemne peste tot acelasi lucru.

  Clasele sunt scrise intregi, nu compuse, ca Tailwind sa le gaseasca la build.
*/
export const TONURI_KPI = {
  comenzi: { card: 'border-l-b4l-blue bg-b4l-blue-light/40', eticheta: 'text-b4l-blue-dark' },
  clienti: { card: 'border-l-b4l-purple bg-b4l-purple-light/40', eticheta: 'text-b4l-purple-dark' },
  venit: { card: 'border-l-b4l-green bg-b4l-green-light/40', eticheta: 'text-b4l-green-dark' },
  discount: { card: 'border-l-b4l-amber bg-b4l-amber-light/40', eticheta: 'text-b4l-amber-dark' },
  retur: { card: 'border-l-b4l-red bg-b4l-red-light/40', eticheta: 'text-b4l-red-dark' },
} as const

export function Kpi({
  ton,
  label,
  value,
  detaliu,
  explicatie,
}: {
  ton: keyof typeof TONURI_KPI
  label: string
  value: string
  detaliu?: ReactNode
  /** Apare la hover — pentru o cifra al carei sens nu reiese din eticheta. */
  explicatie?: string
}) {
  const t = TONURI_KPI[ton]
  return (
    <div
      className={`rounded border border-l-4 border-b4l-border p-3 ${t.card} ${explicatie ? 'cursor-help' : ''}`}
      title={explicatie}
    >
      <div className={`text-[10px] font-medium uppercase tracking-wider ${t.eticheta}`}>
        {label}
      </div>
      <div className="mt-1 text-lg font-semibold">{value}</div>
      {detaliu && <div className="text-[10px] text-b4l-text-muted">{detaliu}</div>}
    </div>
  )
}
